var React = require('react');

function Venus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144,256a80,80,0,1,1,80-80A80,80,0,0,1,144,256Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288,176A144,144,0,1,0,112,316.4V368H76a12,12,0,0,0-12,12v40a12,12,0,0,0,12,12h36v36a12,12,0,0,0,12,12h40a12,12,0,0,0,12-12V432h36a12,12,0,0,0,12-12V380a12,12,0,0,0-12-12H176V316.4A144,144,0,0,0,288,176ZM144,256a80,80,0,1,1,80-80A80,80,0,0,1,144,256Z","className":"fa-primary","key":2})]);
}

Venus.defaultProps = {"viewBox":"0 0 288 512","className":"icon"};

module.exports = Venus;

Venus.default = Venus;
